import { lazy } from 'react'

const LastReloadTimeSessionStorageKey = 'last-reload-from-lazy-import'

const LazyRetry: typeof lazy = (importer) => {
    const retryImport = async () => {
        try {
            return await importer()
        } catch (error) {
            // retry 2 times with 1 second delay
            for (let i = 0; i < 2; i++) {
                await new Promise((resolve) => setTimeout(resolve, 1000))
                try {
                    return await importer()
                } catch (e) {
                    console.log('retrying import: ', e)
                }
            }

            const lastReloadTimeStr = sessionStorage.getItem(
                LastReloadTimeSessionStorageKey,
            )
            const lastReloadTime = lastReloadTimeStr
                ? Number(lastReloadTimeStr)
                : null
            const now = Date.now()

            // reload if lazy import error for the first time, or last reload time more than 10 seconds ago
            const shouldReload = !lastReloadTime || lastReloadTime + 10000 < now

            if (shouldReload) {
                console.log('Reload because failed in Lazy Import...')
                sessionStorage.setItem(
                    LastReloadTimeSessionStorageKey,
                    now.toString(),
                )
                window.location.reload()

                // return empty module to suppress an error before reload
                return { default: () => null } as any
            }

            throw error
        }
    }
    return lazy(retryImport)
}

export default LazyRetry
